import { useEffect } from "react";
import { useHeaderContext } from "@/hooks/useHeaderContext";
import { ForgotPasswordHeader } from "@/components/Page/Header/ForgotPasswordHeader";
import { useSearchParams } from "react-router-dom";
import { RequestPasswordResetForm } from "@/components/Auth/RequestPasswordReset.form";
import { useAuth } from "@/hooks/store/useAuth";
import { Loading } from "@/components/Page/Loading";
import { ResetPasswordForm } from "@/components/Auth/ResetPassword.form";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const oobCode = searchParams.get("oobCode");
  const continueUrl = searchParams.get("continueUrl");
  const continueUrlSearchParams = new URLSearchParams(
    continueUrl?.split("?")[1] ?? undefined
  );
  const template = continueUrlSearchParams.get("template");

  const { status, verifyPasswordResetCode } = useAuth();
  const { setHeaderContent } = useHeaderContext();

  useEffect(() => {
    setHeaderContent(<ForgotPasswordHeader />);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  useEffect(() => {
    if (!oobCode || status !== "idle") {
      return;
    }
    verifyPasswordResetCode(oobCode);
  }, [oobCode, status, verifyPasswordResetCode]);

  const onSubmit = () => {
    setTimeout(() => {
      window.location.href = "/login";
    }, 1000);
  };

  return (
    <div className="m-auto flex flex-col gap-4 bg-slate-900 text-slate-100">
      {(!oobCode || status === "error") && <RequestPasswordResetForm />}
      {status === "verifying" && <Loading />}
      {status === "success" && oobCode && (
        <ResetPasswordForm
          oobCode={oobCode}
          onSubmit={onSubmit}
          type={
            template === "resetPassword"
              ? "resetPassword"
              : template === "inviteUser"
                ? "invitedSetPassword"
                : "resetPassword"
          }
        />
      )}
    </div>
  );
};

export default ResetPasswordPage;
